// extracted by mini-css-extract-plugin
module.exports = {"PartName":"uFQt-B89l23FYLFZGHvkhQ==","PartDetails":"g8upZDVAiGtmU0pZSSXQ7Q=="};